import gql from 'graphql-tag'

export default gql`
mutation createProductList($fields: ProductListReqFields!) {
	cashAssist {
		createProductList(required: $fields) {
			id
			name
		}
	}
}
`
